export const removeLocalStorage = (name: string): void => {
    localStorage.removeItem(name);
};
